import axios from "axios";
import { toast } from "sonner";

export const FETCH_TOOL_SUCCESS = "FETCH_TOOL_SUCCESS";
export const FETCH_TOOLS_SUCCESS = "FETCH_TOOLS_SUCCESS";
export const SEARCH_TOOLS_SUCCESS = "SEARCH_TOOLS_SUCCESS";
export const UPDATE_TOOL_LOVES_SUCCESS = "UPDATE_TOOL_LOVES_SUCCESS";
export const FETCH_SAVED_TOOLS_SUCCESS = "FETCH_SAVED_TOOLS_SUCCESS";
export const FETCH_ALTERNATIVE_TOOLS_SUCCESS =
    "FETCH_ALTERNATIVE_TOOLS_SUCCESS";
export const FETCH_SUBMITTED_TOOLS_SUCCESS = "FETCH_SUBMITTED_TOOLS_SUCCESS";
export const FETCH_ADMIN_TOOLS_SUCCESS = "FETCH_ADMIN_TOOLS_SUCCESS";
export const UPDATE_TOOL_STATUS_SUCCESS = "UPDATE_TOOL_STATUS_SUCCESS";
export const UPDATE_TOOL_INFO_SUCCESS = "UPDATE_TOOL_INFO_SUCCESS";
export const SUBMIT_TOOL_SUCCESS = "SUBMIT_TOOL_SUCCESS";
export const DELETE_TOOL_SUCCESS = "DELETE_TOOL_SUCCESS";
export const FETCH_TOOL_DETAILS_SUCCESS = "FETCH_TOOL_DETAILS_SUCCESS";
export const FETCH_ADMIN_TOOLS_REQUEST = "FETCH_ADMIN_TOOLS_REQUEST";
export const FETCH_ADMIN_TOOLS_FAILURE = "FETCH_ADMIN_TOOLS_FAILURE";
export const SUBMIT_BATCH_TOOLS_SUCCESS = "SUBMIT_BATCH_TOOLS_SUCCESS";
export const SUBMIT_BATCH_TOOLS_FAILURE = "SUBMIT_BATCH_TOOLS_FAILURE";
export const FETCH_TOOLS_REQUEST = "FETCH_TOOLS_REQUEST";
export const FETCH_TOOLS_FAILURE = "FETCH_TOOLS_FAILURE";

export const fetchTool = (toolName) => async (dispatch) => {
    await axios
        .get(`/api/tool/name/${toolName}`)
        .then((response) => {
            dispatch({
                type: FETCH_TOOL_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            toast.error(
                error?.response?.data?.error || "Failed to fetch tool",
                {
                    duration: 3000,
                }
            );
        });
};

export const fetchTools =
    (limit = 20, offset = 0) =>
    async (dispatch) => {
        try {
            dispatch({ type: FETCH_TOOLS_REQUEST });

            const response = await axios.get(
                `/api/tool?limit=${limit}&offset=${offset}`
            );

            dispatch({
                type: FETCH_TOOLS_SUCCESS,
                payload: {
                    tools: response.data.tools,
                    totalCount: response.data.totalCount,
                    hasMore: response.data.hasMore,
                    offset: offset,
                },
            });
        } catch (error) {
            dispatch({
                type: FETCH_TOOLS_FAILURE,
                payload:
                    error?.response?.data?.error || "Failed to fetch tools",
            });
            toast.error(
                error?.response?.data?.error || "Failed to fetch tools",
                {
                    duration: 3000,
                }
            );
        }
    };

export const searchTools = (query) => async (dispatch) => {
    await axios
        .get(`/api/tool/search?q=${encodeURIComponent(query)}`)
        .then((response) => {
            dispatch({
                type: SEARCH_TOOLS_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            toast.error(
                error?.response?.data?.error || "Failed to search tools",
                {
                    duration: 3000,
                }
            );
        });
};

export const updateToolLoves = (toolUuid, userUuid) => async (dispatch) => {
    try {
        const response = await axios.put(`/api/tool/${toolUuid}/love`, {
            userUuid,
        });
        dispatch({
            type: UPDATE_TOOL_LOVES_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to update loves count",
            {
                duration: 3000,
            }
        );
    }
};

export const fetchSavedTools = (userUuid) => async (dispatch) => {
    try {
        const response = await axios.get(
            `/api/tool/saved?userUuid=${userUuid}`
        );
        dispatch({
            type: FETCH_SAVED_TOOLS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to fetch saved tools",
            {
                duration: 3000,
            }
        );
    }
};

export const fetchAlternativeTools =
    (toolUuid, limit = 4) =>
    async (dispatch) => {
        try {
            const response = await axios.get(
                `/api/tool/${toolUuid}/alternatives?limit=${limit}`
            );
            dispatch({
                type: FETCH_ALTERNATIVE_TOOLS_SUCCESS,
                payload: response.data,
            });
        } catch (error) {
            toast.error(
                error?.response?.data?.error ||
                    "Failed to fetch alternative tools",
                {
                    duration: 3000,
                }
            );
        }
    };

export const fetchSubmittedTools = (userUuid) => async (dispatch) => {
    try {
        const response = await axios.get(
            `/api/tool/submitted?userUuid=${userUuid}`
        );
        dispatch({
            type: FETCH_SUBMITTED_TOOLS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to fetch submitted tools",
            {
                duration: 3000,
            }
        );
    }
};

export const fetchAdminTools =
    (page = 1, status = null) =>
    async (dispatch) => {
        try {
            dispatch({ type: FETCH_ADMIN_TOOLS_REQUEST });

            const params = new URLSearchParams({
                page: page.toString(),
                limit: "20",
            });
            if (status) {
                params.append("status", status);
            }

            const response = await axios.get(
                `/api/tool/admin?${params.toString()}`
            );
            dispatch({
                type: FETCH_ADMIN_TOOLS_SUCCESS,
                payload: response.data,
            });
        } catch (error) {
            dispatch({
                type: FETCH_ADMIN_TOOLS_FAILURE,
                payload:
                    error?.response?.data?.error ||
                    "Failed to fetch admin tools",
            });
            toast.error(
                error?.response?.data?.error || "Failed to fetch admin tools",
                {
                    duration: 3000,
                }
            );
        }
    };

export const updateToolStatus = (toolUuid, status) => async (dispatch) => {
    try {
        await axios.put(`/api/tool/${toolUuid}/status`, { status });
        dispatch({
            type: UPDATE_TOOL_STATUS_SUCCESS,
            payload: { uuid: toolUuid, status },
        });
        toast.success(`Tool ${status.toLowerCase()} successfully`);
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to update tool status",
            {
                duration: 3000,
            }
        );
    }
};

export const updateToolInfo =
    (toolUuid, toolData, categoryData) => async (dispatch) => {
        try {
            const updatedToolData = {
                ...toolData,
                categoryId: categoryData.categoryId,
                subCategoryId: categoryData.subCategoryId,
            };
            const response = await axios.put(
                `/api/tool/${toolUuid}`,
                updatedToolData
            );

            // Dispatch success action with the updated tool data
            dispatch({
                type: UPDATE_TOOL_INFO_SUCCESS,
                payload: {
                    ...response.data,
                    categoryId: categoryData.categoryId,
                    subCategoryId: categoryData.subCategoryId,
                },
            });

            // Refresh the tools list
            dispatch(fetchAdminTools());
            toast.success("Tool information updated successfully");
        } catch (error) {
            console.error("Update tool error:", error);
            toast.error(
                error?.response?.data?.error ||
                    "Failed to update tool information",
                {
                    duration: 3000,
                }
            );
        }
    };

export const submitTool = (toolData) => async (dispatch) => {
    try {
        const response = await axios.post("/api/tool", toolData);
        dispatch({
            type: SUBMIT_TOOL_SUCCESS,
            payload: response.data.tool,
        });
        dispatch(fetchAdminTools());
        toast.success(response.data.message);
    } catch (error) {
        if (error.response?.status === 409) {
            // Tool with this URL already exists
            toast.error(
                `A tool with this URL already exists: ${error.response.data.tool.url}`,
                {
                    duration: 5000,
                }
            );
        } else {
            toast.error(
                error?.response?.data?.error || "Failed to submit tool",
                {
                    duration: 3000,
                }
            );
        }
    }
};

export const deleteTool = (toolUuid) => async (dispatch) => {
    try {
        await axios.delete(`/api/tool/${toolUuid}`);
        dispatch({
            type: DELETE_TOOL_SUCCESS,
            payload: { uuid: toolUuid },
        });
        dispatch(fetchAdminTools()); // Refresh the tools list
        toast.success("Tool deleted successfully");
    } catch (error) {
        toast.error(error?.response?.data?.error || "Failed to delete tool", {
            duration: 3000,
        });
    }
};

export const fetchToolDetails = (toolUuid) => async (dispatch) => {
    try {
        const response = await axios.get(`/api/tool/${toolUuid}/details`);
        dispatch({
            type: FETCH_TOOL_DETAILS_SUCCESS,
            payload: response.data,
        });
        return response.data;
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to fetch tool details",
            {
                duration: 3000,
            }
        );
        throw error;
    }
};

export const submitBatchTools = (tools) => async (dispatch) => {
    try {
        const response = await axios.post("/api/tool/batch", { tools });

        dispatch({
            type: SUBMIT_BATCH_TOOLS_SUCCESS,
            payload: response.data.tools,
        });

        // Refresh the tools list
        dispatch(fetchAdminTools());

        toast.success(response.data.message);
        return response.data;
    } catch (error) {
        let errorMessage = "Failed to submit tools";

        if (error.response?.status === 409) {
            // Handle duplicate tools
            const existingTools = error.response.data.existingTools;
            errorMessage = `Some tools already exist:\n${existingTools
                .map((t) => `- ${t.name}: ${t.url}`)
                .join("\n")}`;
        } else if (error.response?.status === 400) {
            // Handle validation errors
            const invalidTools = error.response.data.invalidTools;
            errorMessage = `Invalid tools:\n${invalidTools
                .map((t) => `- ${t.name || "No name"}: ${t.url || "No URL"}`)
                .join("\n")}`;
        }

        dispatch({
            type: SUBMIT_BATCH_TOOLS_FAILURE,
            payload: error.response?.data?.error || errorMessage,
        });

        toast.error(errorMessage, {
            duration: 5000,
        });

        throw error;
    }
};
